import { ClickAwayListener, Grid, IconButton, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import propTypes from 'prop-types';
import { Box } from '@mui/system';
import { Cancel } from '@mui/icons-material';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    main: {
      backgroundColor: 'rgba(0,0,0,.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100%',
      zIndex: 15,
    },
    body: {
      backgroundColor: theme.palette.white.main,
      maxWidth: '500px',
      padding: 8,
      paddingBottom: 32,
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
    },
    close: {
      width: 30,
      height: 30,
    },
  }));
};

function WithPopup(props) {
  const { children, handleClose } = props;

  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();

  // redux
  return (
    <Box className={classes.main}>
      <ClickAwayListener onClickAway={handleClose}>
        <Grid container className={classes.body}>
          <Box display="flex" justifyContent="space-between">
            <IconButton className={classes.close} onClick={handleClose} size="large">
              <Cancel />
            </IconButton>
            <Box mr={2}>
              <img src="/logo512.png" width="30" alt="PrestoBots" />
            </Box>
          </Box>
          {children}
        </Grid>
      </ClickAwayListener>
    </Box>
  );
}

const Props = {
  children: propTypes.node,
  handleClose: propTypes.func,
};

WithPopup.propTypes = Props;

export default WithPopup;
